const RGBMixin = {
  methods: {
    RGB2Hex(rgbVars) {
      const rgbHexVars = rgbVars.map((varItem) => {
        let hex = parseInt(varItem.value, 10).toString(16).slice(-2);
        if (hex.length < 2) {
          hex = `0${hex}`;
        }
        return hex;
      });
      return `#${rgbHexVars.join('')}`;
    },
  },
};

export default RGBMixin;
